import type { RouteObject } from 'react-router-dom'

import { Component as Support } from '@/modules/support/pages/Support'
import { SupportRoutePathsEnum } from '@/modules/support/routes/supportRouteConfig.types'

export const SUPPORT_ROUTES: RouteObject[] = [
  {
    element: <Support />,
    path: SupportRoutePathsEnum.SUPPORT,
  },
]
